import _ from 'lodash';

export default v => _.isObject(v) && !(_.isArray(v) || _.isDate(v) || _.isFunction(v));
